import { render } from "./TheVehicleModelGenerals.vue?vue&type=template&id=8b245388"
import script from "./TheVehicleModelGenerals.vue?vue&type=script&lang=js"
export * from "./TheVehicleModelGenerals.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__